export const getPattern = multipleOf => {
  const decimals = getNumberOfDecimals(multipleOf);
  const regex = multipleOf === 1 || typeof multipleOf === 'undefined' || multipleOf === null ? `^-?\\d*?$` : `^-?\\d*(\\.\\d{0,${decimals}})?$`;
  return regex;
};
export const getNumberOfDecimals = multipleOf => {
  var _String$split;
  return ((_String$split = String(multipleOf).split('.')) == null || (_String$split = _String$split[1]) == null ? void 0 : _String$split.length) || 0;
};
export const getValidNumberInput = (input, multipleOf, previousValidValue, locale) => {
  if (input.trim() === '') {
    return {
      validInput: '',
      validNumber: undefined
    }; // allow clear input
  }
  const inputNumber = inputToNumber(input);
  if (isNumberInputValid(inputNumber, multipleOf) && inputNumber < Number.MAX_SAFE_INTEGER) {
    return {
      validInput: localizeNumberInput(input, locale),
      validNumber: inputNumber
    };
  }
  return previousValidValue ? {
    validInput: previousValidValue,
    validNumber: inputToNumber(previousValidValue)
  } : {
    validInput: '',
    validNumber: undefined
  };
};
const inputToNumber = input => Number(normalizeDecimalSeparator(input));
export const localizeNumberInput = (input, locale) => {
  var _Intl$NumberFormat$fo;
  const decimalSeparator = locale ? (_Intl$NumberFormat$fo = Intl.NumberFormat(locale).formatToParts(1.1).find(part => part.type === 'decimal')) == null ? void 0 : _Intl$NumberFormat$fo.value : undefined;
  return decimalSeparator ? input.replace(/[.,]/, decimalSeparator) : input;
};
export const isNumberInputValid = (value, multipleOf) => {
  const multipleOfRegex = getPattern(multipleOf);
  const validator = new RegExp(multipleOfRegex);
  return validator.test(`${value}`);
};
export const normalizeDecimalSeparator = function (value) {
  if (value === void 0) {
    value = '';
  }
  return value.replace(',', '.');
};
export const isNumberInputPossible = function (value, multipleOf) {
  if (value === void 0) {
    value = '';
  }
  if (multipleOf === 1 && value.indexOf('.') !== -1) {
    return false;
  } else if (value === '.' || value === '-') {
    return true;
  }
  return isNumberInputValid(Number(value), multipleOf);
};
//# sourceMappingURL=numeric-input-utils.js.map